import React, { useEffect, useState } from 'react';
import DataTable from 'react-data-table-component';
import {
  Paper, Box, TextField, Button, IconButton, Modal,
  Typography, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Select, MenuItem, InputLabel, FormControl, Divider
} from "@mui/material";
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import VisibilityIcon from '@mui/icons-material/Visibility';
import AddIcon from '@mui/icons-material/Add';
import SearchIcon from '@mui/icons-material/Search';
import SyncIcon from '@mui/icons-material/Sync';
import CloseIcon from '@mui/icons-material/Close';
import '../../styles/AppStyle.css';
import { useDispatch, useSelector } from 'react-redux';
import { fetchAccountsFromAPI } from '../../Redux/AccountDucks';
import { listTemplatesAPI, deleteTemplateAPI, synchronizeTemplatesAPI } from '../../Redux/TemplateDucks';


export default function TemplateListPage() {
  const [Templates, setTemplate] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filterText, setFilterText] = useState('');
  const [SelectedAccount, setSelectedAccount] = useState("0");
  const [SelectedAccountDialog, setSelectedAccountDialog] = useState("0");

  const [SelectedTemplate, setSelectedTemplate] = useState(null);

  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [templateToDelete, setTemplateToDelete] = useState(null);

  const [openSyncDialog, setOpenSyncDialog] = useState(false);

  const dispatch = useDispatch()
  const accountList = useSelector(store => store.account.accounts)
  const templateList = useSelector(store => store.template.templates)

  useEffect(() => {
    setLoading(true);
    dispatch(fetchAccountsFromAPI());
    dispatch(listTemplatesAPI(SelectedAccount));
  }, []);

  useEffect(() => {
    setTemplate(templateList);
    setLoading(false);
  }, [templateList]);


  const handleChangeOption = (event) => {
    const { value } = event.target;
    setSelectedAccount(value);
    setLoading(true);
    dispatch(listTemplatesAPI(String(value)));
  };

  const handleChangeOptionDialog = (event) => {
    const { value } = event.target;
    setSelectedAccountDialog(value);
  };


  const handleConfirmSync = () => {
    setSelectedAccount(SelectedAccountDialog);
    if (SelectedAccountDialog !== "0" && SelectedAccountDialog !== 0) {
      console.log("Sincronizando plantillas con Meta...");
      // TODO: Aquí puedes despachar una acción de Redux para sincronizar.
      dispatch(synchronizeTemplatesAPI(SelectedAccountDialog));
      setOpenSyncDialog(false);
    }
  };

  const handleViewDetail = (tmplt) => {
    setSelectedTemplate(tmplt);
    //redirecto to detail page
    window.location.href = `/campaigns/templates/${tmplt.id}`;
  };

  const handleAdd = () => {
    // Clear selected Template and open modal for adding new Template
    window.location.href = `/campaigns/templates/new`;
  };

  const handleDelete = (template) => {
    setTemplateToDelete(template); // Store the template to be deleted
    setOpenDeleteDialog(true);   // Open the dialog
  };

  const handleSyncWithMeta = () => {
    if (SelectedAccount !== "0" && SelectedAccount !== 0) {
      console.log("Sincronizando plantillas con Meta...");
      // TODO: Aquí puedes despachar una acción de Redux para sincronizar.
      dispatch(synchronizeTemplatesAPI(SelectedAccount));
    } else {
      setSelectedAccountDialog('0');
      setOpenSyncDialog(true);
      //alert("Por favor, selecciona una cuenta de WhatsApp Business para sincronizar.");
    }
    
  };

  const handleCloseDeleteDialog = () => {
    setOpenDeleteDialog(false);
    setTemplateToDelete(null); // Clear the selected template
  };

  const handleConfirmDelete = () => {
    if (templateToDelete) {
      console.log('Deleting template:', templateToDelete);
      // TODO: Dispatch your delete action here
      dispatch(deleteTemplateAPI(templateToDelete.id));
    }
    handleCloseDeleteDialog(); // Close the dialog after confirming
  };

  const filteredItems = Templates.filter(
    item => (item.Template && item.Template.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.name && item.name.toLowerCase().includes(filterText.toLowerCase()))
  );

  const columns = [
    {
      name: 'ID',
      selector: row => row.id,
      sortable: true,
      maxWidth: "20px"
    },
    {
      name: 'Nombre',
      selector: row => row.name,
      sortable: true,
      grow: 2,
      maxWidth: "900px"
    },
    {
      name: 'Categoría',
      selector: row => row.category,
      sortable: true,
      maxWidth: "900px"
    },
    {
      name: 'Estado en WhatsApp',
      selector: row => row.status,
      sortable: true,
      maxWidth: "200px"
    },
    {
      name: 'Activa',
      selector: row => row.active ? 'Sí' : 'No',
      sortable: true,
      maxWidth: "100px"
    },
    {
      name: 'Fecha de Creación',
      selector: row => row.createdAt,
      sortable: true,
      maxWidth: "900px"
    },
    {
      name: 'Acciones',
      cell: row => (
        <Box>
          <IconButton onClick={() => handleViewDetail(row)} size="small" className="apple-button apple-tooltip">
            <VisibilityIcon fontSize="small" />
            <span className="tooltiptext">Ver Detalle</span>
          </IconButton>
          <IconButton onClick={() => handleDelete(row)} size="small" className="apple-button apple-tooltip">
            <DeleteIcon color="error" fontSize="small" />
            <span className="tooltiptext">Eliminar</span>
          </IconButton>
        </Box>
      ),
    },
  ];

  const subHeaderComponentMemo = React.useMemo(() => {
    return (
      <Box className="apple-card" sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%', mb: 2 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', width: '50%' }}>
          <div className="apple-search-container">
            <SearchIcon className="apple-search-icon" />
            <input
              type="text"
              placeholder="Buscar por nombre de plantilla"
              onChange={e => setFilterText(e.target.value)}
              className="apple-search-input"
              style={{minWidth:"250px"}}
            />
          </div>
          <FormControl variant="outlined" className="apple-select" sx={{ ml: 2 }} fullWidth>
            <InputLabel id="business-line-label" sx={{background:"#FFFF"}}>Cuenta de WhatsApp Business</InputLabel>
            <Select
              labelId="business-line-label"
              label="Línea de Negocio"
              value={SelectedAccount}
              onChange={handleChangeOption}
              size='small'
              sx={{maxWidth:'200px'}}
            >
              <MenuItem value={"0"}>Todas</MenuItem>
              {accountList.map((option) => (
                <MenuItem key={option.id} value={option.id}>{option.number}</MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
        <Box>
          <Button
            variant="outlined"
            startIcon={<SyncIcon />}
            onClick={handleSyncWithMeta}
            className="apple-button"
            sx={{ mr: 1 }} // Margen a la derecha para separar los botones
          >
            Sincronizar con Meta
          </Button>
          <Button
            variant="contained"
            startIcon={<AddIcon />}
            onClick={handleAdd}
            className="apple-button"
          >
            Agregar Plantilla
          </Button>
        </Box>
      </Box>
    );
  }, [filterText, SelectedAccount, accountList]);

  return (
    <div className="apple-container" >
      <Paper className="apple-card">
        <DataTable
          columns={columns}
          data={filteredItems}
          pagination
          paginationPerPage={10}
          paginationRowsPerPageOptions={[10, 20, 30]}
          subHeader
          subHeaderComponent={subHeaderComponentMemo}
          progressPending={loading}
          persistTableHead
          customStyles={customStyles}
        />
      </Paper>

      {/* --- DELETE CONFIRMATION DIALOG --- */}
      <Dialog
        open={openDeleteDialog}
        onClose={handleCloseDeleteDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Confirmar eliminación"}
        </DialogTitle>
        <Divider />
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            ¿Estás seguro de que quieres eliminar la plantilla "<span style={{fontWeight:'bold'}}>{templateToDelete?.name}</span>"?
            <Box sx={{ backgroundColor: '#FFF3F3', padding: 2, borderRadius: 1, mt: 2 }}>
              <Typography variant="body2" color="error" component="span" sx={{ fontWeight: 'bold' }}>
              Esta acción es irreversible y también eliminará la plantilla de Meta.
              </Typography>
            </Box>
            
          </DialogContentText>
        </DialogContent>
        <Divider />
        <DialogActions sx={{ padding: '16px' }}>
          <Button size='small' onClick={handleCloseDeleteDialog} variant="outlined" className="apple-button">Cancelar</Button>
          <Button size='small' onClick={handleConfirmDelete} variant="contained" color="primary" className="apple-button" autoFocus>
            Eliminar
          </Button>
        </DialogActions>
      </Dialog>
      {/* ------------------------------------ */}

      {/* --- SYNC CONFIRMATION DIALOG --- */}
      <Dialog
        open={openSyncDialog}
        onClose={() => setOpenSyncDialog(false)}
        aria-labelledby="sync-dialog-title"
        aria-describedby="sync-dialog-description"
      >        
        <DialogTitle id="sync-dialog-title">
          {"Sincronizar Plantillas con Meta"}
        </DialogTitle>
         <IconButton
          aria-label="close"
          onClick={() => setOpenSyncDialog(false)}
          sx={(theme) => ({
            position: 'absolute',
            right: 8,
            top: 8,
            color: theme.palette.grey[500],
          })}
        >
          <CloseIcon />
          </IconButton>
        <Divider />
        <DialogContent>
          <DialogContentText id="sync-dialog-description">
            Por favor, selecciona una cuenta de WhatsApp Business para sincronizar.
          </DialogContentText>
          <FormControl variant="outlined" className="apple-select" sx={{ mt: 2 }} fullWidth>
            <InputLabel id="business-line-label" sx={{background:"#FFFF"}}>Cuenta de WhatsApp Business</InputLabel>
            <Select
              labelId="business-line-label"
              label="Línea de Negocio"
              value={SelectedAccountDialog}
              onChange={handleChangeOptionDialog}
              size='small'
              sx={{maxWidth:'100%'}}
            >
              {accountList.map((option) => (
                <MenuItem key={option.id} value={option.id}>{option.number}</MenuItem>
              ))}
            </Select>
          </FormControl>
        </DialogContent>
        <Divider />
        <DialogActions>
          <Button size='small' onClick={handleConfirmSync} variant="contained" color="primary" className="apple-button" disabled={SelectedAccountDialog == '0'} autoFocus>
            Sincronizar
          </Button>
        </DialogActions>
      </Dialog>

    </div>
  );

}

const customStyles = {
  table: {
    style: {
      minWidth: '80vw',
      maxWidth: '90vw'
    },
  },
  headRow: {
    style: {
      backgroundColor: '#F2F2F7',
      borderBottom: 'none',
    },
  },
  headCells: {
    style: {
      fontSize: '12px',
      fontWeight: '600',
      color: '#86868B',
      textTransform: 'uppercase',
    },
  },
  cells: {
    style: {
      fontSize: '14px',
      color: '#1D1D1F',
    },
  },
};